module.exports = __webpack_public_path__ + "static/media/uniOjo.f9ece772.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/uniOjo.png
// module id = 941
// module chunks = 0